import type { ReactNode } from "react";

import { sectionSurface } from "@/shared/config";

/**
 * Иконка в цветном скруглённом квадрате.
 *
 * Один и тот же приём на трёх уровнях — шапка страницы, плитка сводки,
 * заголовок карточки, — поэтому вынесен отдельно: иначе три набора одинаковых
 * инлайновых стилей разъезжаются по размеру уже на второй правке.
 */
export function SectionIcon({
  color,
  size = 36,
  children,
}: {
  color: string;
  size?: number;
  children: ReactNode;
}) {
  return (
    <span
      aria-hidden
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
        width: size,
        height: size,
        borderRadius: size / 3,
        background: sectionSurface(color),
        color,
        fontSize: Math.round(size / 2),
        lineHeight: 1,
      }}
    >
      {children}
    </span>
  );
}
